import React from 'react'
// import { Container } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { FaInstagram } from "fontawsome/free-brand-svg-icons";
// import {FaLinkedin,FaInstagram,FaTwitter} from 'react-icons/fa'
const FooterBottom = () => {
  return (
    <div className="w-full py-10">
    <div ></div>
      <p className="text-center text-gray-500 text-base">
        {/* <a href='linkedin.com/in/himanshu-bisht-b51943166'>
        
      <FaLinkedin className='icons linkdin'/>
      </a>
      <FaInstagram/>
      <FaTwitter/> */}
        © 2023. All rights reserved by Himanshu Bisht
      </p>
    </div>
  );
}    

export default FooterBottom